export default "__VITE_ASSET__1200be12__"